export function toJsonSafe(value) {
  if (value == null) return value;
  if (typeof value.toDate === 'function') {
    try {
      return value.toDate().toISOString();
    } catch {
      return null;
    }
  }
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return value.map(toJsonSafe);
  if (typeof value === 'object') {
    if (
      Object.prototype.hasOwnProperty.call(value, 'seconds') &&
      Object.prototype.hasOwnProperty.call(value, 'nanoseconds')
    ) {
      return new Date(Number(value.seconds) * 1000).toISOString();
    }
    const out = {};
    Object.entries(value).forEach(([key, nested]) => {
      out[key] = toJsonSafe(nested);
    });
    return out;
  }
  return value;
}
